import { FrSortMenu } from '../fr-list/components/fr-sort-menu';
import { useUnitsSortColumns } from './use-units-sort-columns';

export function FrUnitsSortMenu() {
    const columns = useUnitsSortColumns();

    return <FrSortMenu compact defaultColumnDefinition="CALL_SIGN" columns={columns} />;
}
